import Cookies from 'js-cookie';

class NotificationCookies
{
    constructor() {
        this.cookieConfig = [
            {
                name: "startupSaveDate",
                value: "2024-03-31"
            },
            {
                name: "exteriorTabOpened",
                value: "2025-01-02"
            },
        ];
    }

    setCookie(name, value) {
        const cookieInfo = this.cookieConfig.find(cookie => cookie.name === name);
        if (cookieInfo) {
            Cookies.set(name, value, { expires: 365 }); // Set cookie to expire in 1 year
        } else {
            console.warn(`Cookie ${name} is not defined in the configuration.`);
        }
    }

    getCookie(name) {
        return Cookies.get(name);
    }

    shouldShowAlert(name) {
        const cookieInfo = this.cookieConfig.find(cookie => cookie.name === name);
        if (!cookieInfo) {
            console.warn(`Cookie ${name} is not defined in the configuration.`);
            return false;
        }

        const savedValue = this.getCookie(name);
        if (!savedValue) {
            return true; // Show alert if cookie doesn't exist
        }

        const savedDate = new Date(savedValue);
        const currentDate = new Date(cookieInfo.value);
        return currentDate > savedDate;
    }

    markAlertShown(name) {
        const cookieInfo = this.cookieConfig.find(cookie => cookie.name === name);
        if (cookieInfo) {
            this.setCookie(name, cookieInfo.value);
        } else {
            console.warn(`Cookie ${name} is not defined in the configuration.`);
        }
    }
}

export default new NotificationCookies(); // Export a singleton instance